import * as yup from 'yup';
import { createCompanyEmployeeFormFields } from '../../fields/formFields/createCompanyEmployee';
import { createCompanyEmployeeSchema } from './createCompanyEmployee';

/**
 * The treasury employee (the company owner): the Create Employee rules, except the salary — hidden and sent as 0,
 * since treasury money never reads it (thriftplan only refuses a negative salary).
 */
export const treasuryEmployeeSchema = createCompanyEmployeeSchema.shape({
  [createCompanyEmployeeFormFields.salary]: yup.number().min(0).required(),
});
